import inputBorderPrimary from '../../input/border-color/default/primary';

const primary = (params) => inputBorderPrimary(params);

export default primary;
